<template>
  <section class="section container">
    <div class="title is-3 has-text-centered">{{ $t("account requests") }}</div>

    <!-- Estadísticas Principales -->
    <div class="grid is-col-min-10 mb-6" v-show="false">
      <!-- Total Solicitudes -->
      <div class="cell">
        <div class="card has-background-primary-dark">
          <div class="card-content">
            <div class="level">
              <div class="level-left">
                <div class="level-item">
                  <div>
                    <p class="heading">{{ $t("total requests") }}</p>
                    <p class="title">{{ stats.total_requests }}</p>
                  </div>
                </div>
              </div>
              <div class="level-right">
                <div class="level-item">
                  <figure class="image is-48x48">
                    <i class="fa fa-file-alt fa-2x has-text-primary"></i>
                  </figure>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Pendientes -->
      <div class="cell">
        <div class="card has-background-warning-dark">
          <div class="card-content">
            <div class="level">
              <div class="level-left">
                <div class="level-item">
                  <div>
                    <p class="heading">{{ $t("pending requests") }}</p>
                    <p class="title">{{ stats.pending_requests }}</p>
                  </div>
                </div>
              </div>
              <div class="level-right">
                <div class="level-item">
                  <figure class="image is-48x48">
                    <i class="fa fa-clock fa-2x has-text-warning"></i>
                  </figure>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Completadas -->
      <div class="cell">
        <div class="card has-background-success-dark">
          <div class="card-content">
            <div class="level">
              <div class="level-left">
                <div class="level-item">
                  <div>
                    <p class="heading">{{ $t("completed requests") }}</p>
                    <p class="title">{{ stats.completed_requests }}</p>
                  </div>
                </div>
              </div>
              <div class="level-right">
                <div class="level-item">
                  <figure class="image is-48x48">
                    <i class="fa fa-check-circle fa-2x has-text-success"></i>
                  </figure>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Este Mes -->
      <div class="cell">
        <div class="card has-background-info-dark">
          <div class="card-content">
            <div class="level">
              <div class="level-left">
                <div class="level-item">
                  <div>
                    <p class="heading">{{ $t("this month") }}</p>
                    <p class="title">{{ stats.this_month }}</p>
                  </div>
                </div>
              </div>
              <div class="level-right">
                <div class="level-item">
                  <figure class="image is-48x48">
                    <i class="fa fa-calendar fa-2x has-text-info"></i>
                  </figure>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Cards de Navegación Principal -->
    <div class="grid is-col-min-10">
      <!-- Gestionar Solicitudes -->
      <div class="cell" @click="personal_savings_account">
        <div class="card navigation-card">
          <div class="card-image">
            <figure class="image is-64x64 m-auto py-4">
              <img
                src="https://cdn-icons-png.freepik.com/512/8634/8634075.png"
              />
            </figure>
          </div>
          <div class="card-content px-0">
            <div class="media">
              <div class="media-content">
                <p class="title is-5 has-text-centered">
                  {{ $t("personal savings account") }}
                </p>
                <p class="subtitle is-6 has-text-centered has-text-grey">
                  {{
                    $t("create and review personal savings account requests")
                  }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Configuración -->
      <!-- <div class="cell" @click="manage_settings">
        <div class="card navigation-card">
          <div class="card-image">
            <figure class="image is-64x64 m-auto py-4">
              <img
                src="https://cdn-icons-png.flaticon.com/256/3524/3524659.png"
              />
            </figure>
          </div>
          <div class="card-content px-0">
            <div class="media">
              <div class="media-content">
                <p class="title is-5 has-text-centered">
                  {{ $t("settings") }}
                </p>
                <p class="subtitle is-6 has-text-centered has-text-grey">
                  Configurar parámetros del módulo
                </p>
              </div>
            </div>
          </div>
        </div>
      </div> -->

      <!-- Transference requests -->
      <div class="cell" @click="transference_requests">
        <div class="card navigation-card">
          <div class="card-image">
            <figure class="image is-64x64 m-auto py-4">
              <img
                src="https://cdn-icons-png.flaticon.com/512/6404/6404655.png"
              />
            </figure>
          </div>
          <div class="card-content px-0">
            <div class="media">
              <div class="media-content">
                <p class="title is-5 has-text-centered">
                  {{ $t("transference requests") }}
                </p>
                <p class="subtitle is-6 has-text-centered has-text-grey">
                  {{ $t("create and review transference requests") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Update requests -->
      <div class="cell" @click="update_requests">
        <div class="card navigation-card">
          <div class="card-image">
            <figure class="image is-64x64 m-auto py-4">
              <img
                src="https://cdn-icons-png.flaticon.com/512/6713/6713079.png"
              />
            </figure>
          </div>
          <div class="card-content px-0">
            <div class="media">
              <div class="media-content">
                <p class="title is-5 has-text-centered">
                  {{ $t("update requests") }}
                </p>
                <p class="subtitle is-6 has-text-centered has-text-grey">
                  {{ $t("create and review update requests") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Destinatarios -->
      <div class="cell" @click="destinataries">
        <div class="card navigation-card">
          <div class="card-image">
            <figure class="image is-64x64 m-auto py-4">
              <img
                src="https://cdn-icons-png.flaticon.com/512/9101/9101870.png"
              />
            </figure>
          </div>
          <div class="card-content px-0">
            <div class="media">
              <div class="media-content">
                <p class="title is-5 has-text-centered">
                  {{ $t("destinataries") }}
                </p>
                <p class="subtitle is-6 has-text-centered has-text-grey">
                  {{ $t("manage destinataries") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Entities -->
      <div class="cell" @click="entities">
        <div class="card navigation-card">
          <div class="card-image">
            <figure class="image is-64x64 m-auto py-4">
              <img
                src="https://cdn-icons-png.freepik.com/512/9166/9166850.png"
              />
            </figure>
          </div>
          <div class="card-content px-0">
            <div class="media">
              <div class="media-content">
                <p class="title is-5 has-text-centered">
                  {{ $t("entities") }}
                </p>
                <p class="subtitle is-6 has-text-centered has-text-grey">
                  {{ $t("manage entities") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Products -->
      <div class="cell" @click="products">
        <div class="card navigation-card">
          <div class="card-image">
            <figure class="image is-64x64 m-auto py-4">
              <img
                src="https://cdn-icons-png.flaticon.com/512/5347/5347785.png"
              />
            </figure>
          </div>
          <div class="card-content px-0">
            <div class="media">
              <div class="media-content">
                <p class="title is-5 has-text-centered">
                  {{ $t("products") }}
                </p>
                <p class="subtitle is-6 has-text-centered has-text-grey">
                  {{ $t("manage products") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { warning_message } from "@/utils";

export default {
  name: "AccountRequestIndex",
  components: {},
  data() {
    return {
      is_loading: false,
      stats: {
        total_requests: 247,
        pending_requests: 18,
        completed_requests: 229,
        this_month: 45,
      },
    };
  },
  methods: {
    personal_savings_account() {
      this.$router.push({ path: "/account-request/personal-savings" });
    },
    manage_settings() {
      this.$router.push({ path: "/account-request/settings" });
    },
    transference_requests() {
      this.$router.push({ path: "/account-request/transferences" });
    },
    update_requests() {
      this.$router.push({ path: "/account-request/updates" });
    },
    destinataries() {
      this.$router.push({ path: "/account-request/destinataries" });
    },
    manage_entities() {
      this.$router.push({ path: "/account-request/entities" });
    },
    load_stats() {
      // Aquí cargarías las estadísticas reales desde el backend
      // Por ahora usamos datos simulados
    },
    entities() {
      this.$router.push({ path: "/account-request/entities" });
    },
    products() {
      this.$router.push({ path: "/account-request/products" });
    },
  },
  created() {
    this.load_stats();
  },
};
</script>

<style scoped>
.navigation-card:hover {
  border-radius: 0.5em;
  box-shadow: 0px 0px 5px 1px rgba(0, 209, 178, 0.9);
  transition: linear 0.1s;
  transform: scale(1.05, 1.05);
}

.navigation-card:active {
  border-radius: 20px;
  box-shadow: 0px 0px 5px 1px rgba(0, 209, 178, 0.9);
  transition: ease-out 0.3s;
  transform: scale(1.5, 1.5);
  opacity: 0;
}

.navigation-card {
  background-color: rgba(20, 22, 26, 0.4);
}

.card.has-background-primary-dark {
  border-left: 4px solid #3273dc;
}

.card.has-background-warning-dark {
  border-left: 4px solid #ffdd57;
}

.card.has-background-success-dark {
  border-left: 4px solid #23d160;
}

.card.has-background-info-dark {
  border-left: 4px solid #209cee;
}
</style>
